declare const process: {
  env: Record<string, string | undefined>;
};

export const INITIAL_STATE = {
  playbutton: {
    isPlaying: true,
    currentPercent: 0
  },
  assets: [],
  asset: {},
  statusCodeDescription: {
    descriptions: {
      statusCodes: [],
      documentStatusCodes: []
    },
    totals: {
      assetStatus: [],
      documentStatus: []
    }
  },
  rentalBoardSettings: {
    CardSize: "medium",
    OrderBy: "Asset ID",
    paginationAutoAdvance: 15
  },
  rentalBoardPrevSettings: {
    CardSize: "",
    OrderBy: "",
    paginationAutoAdvance: 0
  },
  statusColors: [],
  lastUpdated: "",
  rentalBoardUrl: "",
  rentalBoardPages: {},
  statusCode: {},
  clickToggleButton: false,
  users: { results: [] },
  securityRoles: [],
  mechanicTypes: [],
  workOrders: { results: [] },
  workOrdersMap: { results: [] },
  workers: { results: [] },
  drivers: { results: [] },
  ticketsMap: { results: [] },
  workersMap: { results: [] },
  driversMap: { results: [] },
  tickets: { results: [] },
  products: { results: [] },
  customers: { results: [] },
  returns: { results: [] },
  divisions: { results: [] },
  printers: [],
  workOrderSelected: {},
  contracts: {},
  ticketSelected: {},
  isLoading: false,
  part: [],
  inspections: [],
  selectedAssets: [],
  message: "",
  modal: {
    isTicketModalOpen: false,
    isModalOpen: false,
    printTagType: "red",
    divisionSrmUid: "",
    printerTitle: "",
    isTransfer: false,
    isPrint: false,
    isEmail: false,
    isInvoice: false,
    isClose: false,
    email: "",
    modalType: "",
    modalErrorMessage: "",
    modalUpdateResult: null,
    emailList: []
  },
  countries: [],
  taxes: [],
  auth: {},
  productStatusCodes: { results: [] },
  productClasses: { results: [] },
  productGroups: { results: [] },
  signature: {},
  photoZoom: {
    isOpenLightBox: false,
    imgStartIndex: 0
  },
  yardInspectors: [],
  requestedParts: { results: [] },
  paymentMethods: [],
  customerSitesFromSRM: { sites: [] },
  partSelected: {},
  configEmail: {
    isEmailConfig: false
  }
};

export const SCS_SRM_UID = "000000000000000SCS";
export const SCS_EMAIL_ACCOUNT = "scs@";
export const INTERNAL_EMAIL_ACCOUNT = "@texadasoftware.com";
export const TIS_AUX_TYPE = "5";
export const TIS_DB_CONNECTION = "auth0";
export const TIS_REGISTER_URL = "register";
const RAW_APP_BASE_PATH = process.env.APP_BASE_PATH || "";
const NORMALIZED_APP_BASE_PATH = RAW_APP_BASE_PATH.replace(/^\/+|\/+$/g, "");

export const APP_BASE_PATH = NORMALIZED_APP_BASE_PATH
  ? `/${NORMALIZED_APP_BASE_PATH}`
  : "";
export const HOST_URL = process.env.HOST_URL || "";
export const API_BASE_URL = HOST_URL || APP_BASE_PATH;
export const APP_DEFAULT_URL = "/dashboard/console";
export const APP_DEFAULT_REDIRECT_URL = `${APP_BASE_PATH}${APP_DEFAULT_URL}`;
export const RENTAL_BOARD_URL = "/inventory/rentalBoard";

export const WORKORDER_URL = "/rest-api/workorders/";
export const WORKORDER_SCHEDULES_URL = "/rest-api/workorder_schedules/";
export const WORKORDER_ESTIMATE_URL = "/rest-api/workorder-estimates";
export const SERVICE_COMPONENTS_URL = "/rest-api/service_components/";
export const PART_COMPONENTS_URL = "/rest-api/part_components/";
export const LABOUR_COMPONENTS_URL = "/rest-api/labour_components/";

export const WORKORDER_LAT_LNG_URL =
  "/rest-api/workorders/?lat__isnull=3&lng__isnull=3";
export const WORKER_URL = "/rest-api/mechanics/?page_size=500";
export const WORKER_LAT_LNG_URL =
  "/rest-api/mechanics/?lat__isnull=3&lng__isnull=3";
export const TICKET_ASSIGN_URL = "/rest-api/tickets/";
export const DELIVERY_TICKET_URL = "/rest-api/tickets/delivery/";
export const PICKUP_TICKET_URL = "/rest-api/tickets/pickup/";
export const YARD_INSPECTOR_URL = "/rest-api/yardinspector/";
export const MECHANIC_URL = "/rest-api/mechanics/";
export const DRIVER_URL = "/rest-api/drivers/";
export const RESERVATION_STAGING_USER_URL =
  "/rest-api/reservation-staging-users/";
export const DRIVER_LAT_LNG_URL =
  "/rest-api/drivers?lat__isnull=3&lng__isnull=3&page_size=500";
export const RETURNS_URL = "/in_yard_returns/";
export const WAREHOUSE_URL = "/rest-api/warehouse?page_size=500";
export const PRODUCT_CLASS_URL = "/inventory/product-classes";
export const PRODUCT_GROUP_URL = "/inventory/product-groups";
export const KIT_URL = "/rest-api/srmrecord/kits";
export const TASK_URL = "/rest-api/task/";
export const CLOCK_URL = "/rest-api/clock";
export const REQUESTED_PARTS_URL = "/rest-api/parts/management";
export const PARTS_URL = "/rest-api/parts";
export const WORKORDER_MECHANICS_URL = "/rest-api/workorder_mechanics/";
export const COMPANY_EMAIL_CONFIG = "/rest-api/company/email/";
export const RESET_COMPANY_EMAIL_CONFIG = "/rest-api/company/email/reset";
export const DEFAULT_EMAIL_CONFIG = "/rest-api/configurations/default-email";
export const TICKET_SCHEDULING_URL = "/rest-api/tickets_schedule/";
export const TICKET_MAP_URL = "/rest-api/tickets_map/";
export const AUTH_URL = "/rest-api/auth/";
export const CONTRACTS_URL = "/rest-api/contracts";
export const DOCUMENT_DEFAULT_TAXES_URL = "/rest-api/document-default-taxes/";
export const RESERVATIONS_URL = "/rest-api/reservations";
export const DRAFT_CONTRACTS_URL = "/rest-api/drafts/contracts";
export const QUOTES_URL = "/rest-api/quotes";
export const CREATE_CONTRACT_URL = "/rest-api/create/contract";
export const UPDATE_CONTRACT_URL = "/rest-api/update/contract";
export const DELETE_CONTRACT_URL = "/rest-api/delete/contract";
export const CREATE_DATA_MANAGEMENT_URL = "/rest-api/create/dataManagement";
export const COUNTER_WORKSHEET = "/rest-api/counter-worksheets";
export const INVOICES_URL = "/rest-api/invoices";
export const PAYMENTS_URL = "/rest-api/payments";
export const PAYMENT_INFO_URL = "/rest-api/payment-config";
export const SERVICE_URL = "/rest-api/srmrecord/service/";
export const RESET_PASSWORD_URL = "/rest-api/reset_password";
export const COMPANY_PERMISSION_URL = "/rest-api/permissions/companies/";
export const CUSTOMER_URL = "/rest-api/customers";
export const OVERRIDE_PRICE_URL = "/rest-api/update/getPrice/product/";
export const OVERRIDE_GROUP_PRICE_URL = "/rest-api/update/getPrice/group/";
export const LINK_DOCUMENT_URL = "/rest-api/document-links/";
export const CALENDAR_AVAILABILITY_URL =
  "/rest-api/srmrecord/calendarAvailability";
export const EMAIL_URL = "/rest-api/email/customer/";
export const DOCUMENT_HISTORY_URL = "/rest-api/document-histories/";
export const AVAILABILITY_URL =
  "/rest-api/srmrecord/currentAvailability/product/";
export const GROUP_AVAILABILITY_URL =
  "/rest-api/srmrecord/currentAvailability/group/";
export const CUSTOMER_CREDIT_LIMIT_URL =
  "/rest-api/srmrecord/customercreditlimit/";
export const CUSTOMER_DAMAGE_WAIVER_URL =
  "/rest-api/srmrecord/customerdamagewaiver/";
export const EXCHANGE_URL = "/rest-api/create/exchange/";
export const OPERATOR_URL = "/rest-api/operators";
export const OVERRIDE_REASONS = "/rest-api/srmrecord/overrideReasons";
export const PART_URL = "/parts/";
export const INSPECTION_PHOTO_URL = "/rest-api/inspection-photos";
export const PHOTO_URL = "/rest-api/photos";
export const TIS_SESSION_VERIFY_URL = "/rest-api/auth/session/validate";
export const NON_UPGRADED_USER_URL = "/rest-api/users";
export const ASSET_AVAILABILITY_URL = "/rest-api/assets/availability";
export const PART_AVAILABILITY_URL = "/rest-api/parts/availability";
export const GROUPS_AVAILABILITY_URL = "/rest-api/groups/availability";
export const CUSTOMER_OWNED_URL = "/rest-api/create/customerEquipment";
export const UPDATE_CUSTOMER_OWNED_URL = "/rest-api/edit/customerEquipment";
export const CREATE_RESERVATION_URL = "/rest-api/create/reservation";
export const CREATE_QUOTE_URL = "/rest-api/create/quote";
export const QUOTE_TO_RESERVATION_CONVERT_URL = quoteNumber =>
  `/rest-api/quote-to-reservation/${quoteNumber}/convert`;
export const QUOTE_TO_CONTRACT_CONVERT_URL = quoteNumber =>
  `/rest-api/quote-to-contract/${quoteNumber}/convert`;
export const UPDATE_RESERVATION_TO_CONVERT_URL = reservationNumber =>
  `/rest-api/edit/reservationToContract/${reservationNumber}`;
export const UPDATE_RESERVATION_URL = reservationNumber =>
  `/rest-api/reservations/${reservationNumber}`;
export const IN_YARD_RETURN_RETURN_URL = "/rest-api/in_yard_returns/";
export const FLASK_IN_YARD_RETURN_URL = "/in_yard_returns/";
export const DAMAGE_DETECTION_URL = "/rest-api/damage-detections";
export const DAMAGE_DETECTION_STATUS_URL = "/rest-api/damage-detection-status";
export const IN_YARD_RETURN_RETURN_DETAILS_URL = (
  requestId,
  requestHash,
  contractNumber
) => {
  return `/rest-api/in-yard-returns/${requestId}/${requestHash}/${contractNumber}/`;
};

export const USER_URL = "/auth/users/";
export const USER_ROLE_URL = "/auth/user-roles/";
export const USER_PERMISSION_URL = "/auth/user-permissions/";
export const USER_MIGRATE_STATUS = "/auth/users/migrate-status";
export const WAREHOUSES_URL = "/auth/warehouses/";
export const ROLE_HEADER_URL = "/auth/role-headers/";
export const ROLE_URL = "/auth/roles/";
export const USER_INSTANCE_URL = "/auth/user-instances";
export const PERMISSION_URL = "/auth/permissions/";
export const VERIFY_EMAIL_URL = "/auth/email/verification";
export const FORGET_PASSWORD_URL = "/auth/forget-password";
export const AUTH_MECHANIC_URL = "/auth/mechanics/";
export const AUTH_DRIVER_URL = "/auth/drivers/";
export const AUTH_YARD_INSPECTOR_URL = "/auth/yardinspector/";
export const AUTH_RESERVATION_STAGING_USER_URL =
  "/auth/reservation-staging-users/";
export const AUTH_MULTIFACTOR_AUTHENTICATION = "/auth/mfa";
export const INSTANCE_URL = "/auth/instances";
export const COMPANY_URL = "/auth/companies";
export const NON_UPGRADED_COMPANY_URL = "/rest-api/companies";
export const EQUIPMENT_TYPE_URL = "/inventory/customer-owned/equipment-types";

export const SERVER_ERROR_500 =
  "Internal server error. Please try again later or contact Texada Software.";
export const COMPANY_UPGRADED_ERROR =
  "Company has been upgraded, please use Texada Web login page.";

export const GMAIL_AUTH_URL = "https://accounts.google.com/o/oauth2/v2/auth";
export const GMAIL_SCOPE = "profile+email+https://mail.google.com/";
export const REDIRECT_URL = "/oauth/verify";

export const MS_AUTH_URL =
  "https://login.microsoftonline.com/common/oauth2/v2.0/authorize";
export const MS_SCOPE =
  "openid profile email offline_access https://graph.microsoft.com/Mail.Send";

// V1 urls
const V1_API_BASE = "/rest-apis/v1";

export const V1_WORKORDER_URL = `${V1_API_BASE}/work-orders`;
export const V1_WORKORDER_LAT_LNG_URL = `${V1_API_BASE}/work-orders?lat__isnull=3&lng__isnull=3`;
export const WORKORDER_SUBRESOURCE_QUERY = [
  "partcomponent_set",
  "labourcomponent_set",
  "servicecomponent_set",
  "workordermechanic_set",
  "workorderinspection_set",
  "maintenanceschedule_set",
  "workordercustomizedfield_set"
];
export const V1_PICKUP_TICKET_URL = `${V1_API_BASE}/pickup-tickets`;
export const V1_DELIVERY_TICKET_URL = `${V1_API_BASE}/delivery-tickets`;
export const V1_TASK_URL = `${V1_API_BASE}/task-tickets`;
export const TICKET_SUBRESOURCE_QUERY = ["ticketasset_set"];

export const FLASK_ERROR_CODES = {
  AUTH_EXPIRED_TOKEN: 1001,
  AUTH_INVALID_TOKEN: 1002
};
export const GATEWAY_ERROR_CODES = {
  AUTH_EXPIRED_TOKEN: 1001,
  AUTH_INVALID_TOKEN: 1002
};
export const GA_TRACKING_CODES_BY_HOST = {
  // 1: North America
  app: "UA-154130614-1",
  fleetlogic: "UA-154130614-1",
  // 2: APAC
  "app-apac": "UA-154130614-2",
  "fleetlogic-apac": "UA-154130614-2",
  // 3: Hirepool
  hirepool: "UA-154130614-3",
  // 4: Dev/QA ("dev" = default if no subdomain match)
  dev: "UA-154130614-4",
  fl3: "UA-154130614-4",
  "hirepool-uat": "UA-154130614-4",
  "fleetlogic-dev": "UA-154130614-4",
  "fleetlogic-qa": "UA-154130614-4",
  "fleetlogic-ap": "UA-154130614-4",
  // 5: Play
  "dev-play": "UA-154130614-5",
  "qa-play": "UA-154130614-5",
  "fl3-play": "UA-154130614-5",
  play: "UA-154130614-5",
  "play-apac": "UA-154130614-5"
};

export const AUTO_REFRESH_INTERVAL = 30000;
export const AUTO_DRAFT_UPDATE_INTERVAL = 10000;
export const TWO_MINUTE_INTERVAL = 120000;
export const Colors = {
  K400: "#b5bbc0"
};
export const NOT_APPLICABLE = "N/A";

export const GLOBAL_SITE_NUMBER = "*";

export const HEADOFFICE_OPTION_VALUE = " ";
export const DEFAULT_COMMENT_SIZE = 250;
export const EXCHANGE_COMMENT_SIZE = 60;
export const DEFAULT_MEDIUM_COMMENT_SIZE = 1000;
export const PART_AND_LABOUR_COMMENT_SIZE = 1000;
export const TICKET_COMMENT_SIZE_LIMIT_MSG =
  "Comments are temporarily restricted to 250 characters";

export const EXPORT_TYPE = {
  EXCEL: "excel",
  CSV: "csv"
};

export const MONTH_OFFSET = 29;
export const FULL_PERCENTAGE = 100;
export const ALERT_ERROR_TIMEOUT = 8000;

export const TAX_TYPE = {
  STANDARD: "S",
  ENHANCED: "E"
};

export const CHARGE_VALUE_TYPE = {
  PERCENTAGE: "percentage",
  DOLLAR: "dollar"
};

export const NOTIFICATION_TYPE = {
  GENERIC: 0,
  DELIVERY: 1,
  PICKUP: 2,
  WORK_ORDER: 3,
  TASK: 4
};

export const DISABLE_BROWSER_CACHE = {
  "Cache-Control": "no-cache",
  Pragma: "no-cache",
  Expires: "0"
};

export const VIEW_SETTING_ID = {
  RENTAL_BOARD_COLOR: "RentalboardColors"
};

export const TW_BLUE = "#47C2B1";

export const lAT_LNG_BOUNDS = {
  north: 85,
  south: -85,
  west: -180,
  east: 180
};

export const DEFAULT_SELECTED_MENU = "texada-web";

export const CATEGORY_TYPE = {
  RENT: "rent",
  BUY: "buy"
};

export const PRODUCT_LAYOUT = {
  LIST: "list",
  CARD: "card"
};

export const GW_BOOLEAN = { TRUE: "1", FALSE: "0" };
export const CKEDITOR_KEY = process.env.CKEDITOR_KEY;

export const GW_EMAIL_CONFIG_KEYS = {
  NOTIFICATION_EMAIL: "NOTIFICATION_EMAIL",
  EMAIL_PROVIDER: "NOTIFICATION_EMAIL_PROVIDER",
  OAUTH_2_TOKEN: "NOTIFICATION_EMAIL_OAUTH2_TOKEN",
  SMTP_HOST: "NOTIFICATION_EMAIL_SMTP_HOST",
  SMTP_PORT: "NOTIFICATION_EMAIL_SMTP_PORT",
  SMTP_PASS: "NOTIFICATION_EMAIL_SMTP_PASS",
  SMTP_ENCRYPTION: "NOTIFICATION_EMAIL_SMTP_ENCRYPT"
};

export const GW_CONFIG_KEYS = {
  COMPANY_NAME: "COMPANY_NAME",
  PHONE: "PHONE",
  ADDRESS_ONE: "ADDRESSONE",
  ADDRESS_TWO: "ADDRESSTWO",
  PICKUP_REQUEST_EMAIL: "PICKUP_REQUEST_EMAIL",
  RESERVATION_REQUEST_EMAIL: "RESERVATION_REQUEST_EMAIL",
  SERVICE_REQUEST_EMAIL: "SERVICE_REQUEST_EMAIL",
  ACCOUNTS_RECEIVABLE_EMAIL: "ACCOUNTS_RECEIVABLE_EMAIL",
  SALES_ONLY_CHECKOUT_MESSAGE: "sales_only_checkout_message",
  RENTALS_ONLY_CHECKOUT_MESSAGE: "rentals_only_checkout_message",
  RENTALS_SALES_CHECKOUT_MESSAGE: "rentals_sales_checkout_message",
  CITY: "city",
  PROV_STATE: "prov_state",
  POSTAL_CODE: "postal_code",
  MAIN_TITLE: "site_content_main_title",
  LOGO: "COMPANY_LOGO",
  CREDIT_CARD_PROHIBITED:
    "prohibit_credit_card_invoice_payment_for_serialized_part",
  DEFAULT_RENTAL_PERIOD_IN_DAYS: "Default_rental_period_in_days",
  MINIMUM_DAYS_OUT_FOR_RENTAL: "Minimum_days_out_for_rental",
  PRIMARY_COLOR: "primary_color",
  NAVIGATION_HIGHLIGHT_BAR_COLOR: "navigation_highlight_bar_color",
  NAVIGATION_TEXT_COLOR: "navigation_text_color",
  BUTTON_COLOR: "button_color",
  BACKGROUND_COLOR: "background_color",
  TEXT_COLOR: "text_color",
  DEFAULT_PRIMARY_COLOR: "default_primary_color",
  DEFAULT_NAVIGATION_HIGHLIGHT_BAR_COLOR:
    "default_navigation_highlight_bar_color",
  DEFAULT_NAVIGATION_TEXT_COLOR: "default_navigation_text_color",
  DEFAULT_BUTTON_COLOR: "default_button_color",
  DEFAULT_BACKGROUND_COLOR: "default_background_color",
  DEFAULT_TEXT_COLOR: "default_text_color",
  CREDIT_CARD_FEES: "credit_card_fees"
};

export const GW_EMAIL_PROVIDER = {
  GOOGLE: "Google",
  MICROSOFT: "Office365",
  OTHER: "Other"
};

export const GW_EMAIL_ENCRYPTION = {
  NONE: "none",
  SSL: "ssl",
  TLS: "tls"
};

export const ALLOWED_EXTENSTIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".bmp",
  ".webp",
  ".heic",
  ".psd",
  ".tiff"
];

export const GATEWAY_CAROUSEL_COLOURS = {
  white: "white",
  black: "black",
  red: "red",
  green: "green",
  orange: "orange",
  yellow: "yellow",
  blue: "blue"
};

export const GATEWAY_CAROUSEL_STYLE = {
  simple: "1",
  showcase: "2"
};

export const GATEWAY_ATTRIBUTE_TYPE = {
  PRODUCT: "product",
  CATEGORY: "category"
};

export const COUNTRY_NAME = {
  AUSTRALIA: "Australia"
};

export const BLANK = "";

export const DEBOUNCED_DURATION = {
  FIVE: 5,
  FIFTY: 50,
  HUNDRED: 100,
  TWO_HUNDRED: 200,
  FIFTEEN_HUNDRED: 1500,
  TWO_THOUSAND: 2000
};

export const ATTRIBUTE_VALUE_TYPE = {
  CATEGORY: "category",
  PRODUCT: "product"
};

export const ASSET_DOC_STATUS = {
  AVAILABLE: "A"
};

export const GATEWAY_SERVICE_REQUEST_STATUS = {
  pending: "pending",
  completed: "completed"
};

export const GATEWAY_ORDERS_STATUS = {
  open: "open",
  completed: "completed"
};

export const MINIMUM_AVAILABLE_QUANTITY = 1;

export const GATEWAY_MAX_RICHTEXT_CONTENT_LENGTH = 16777215;

export enum GLOBAL_ENV {
  PLAY_ENVIRONMENT = "PLAY_ENVIRONMENT",
  LIVE_ENVIRONMENT = "LIVE_ENVIRONMENT",
  TIS_LOGIN_URL = "TIS_LOGIN_URL",
  TIS_LOGOUT_URL = "TIS_LOGOUT_URL",
  TIS_ENVIRONMENT = "TIS_ENVIRONMENT"
}

export const ENV_MAP = {
  // Default
  [GLOBAL_ENV.TIS_LOGIN_URL]: process.env.TIS_LOGIN_URL,
  [GLOBAL_ENV.TIS_LOGOUT_URL]: process.env.TIS_LOGOUT_URL,
  [GLOBAL_ENV.TIS_ENVIRONMENT]: process.env.TIS_ENVIRONMENT,
  // DEV
  [`${GLOBAL_ENV.PLAY_ENVIRONMENT}_DEV`]: process.env.PLAY_ENVIRONMENT_DEV,
  [`${GLOBAL_ENV.LIVE_ENVIRONMENT}_DEV`]: process.env.LIVE_ENVIRONMENT_DEV,
  [`${GLOBAL_ENV.TIS_LOGIN_URL}_DEV`]: process.env.TIS_LOGIN_URL_DEV,
  [`${GLOBAL_ENV.TIS_LOGOUT_URL}_DEV`]: process.env.TIS_LOGOUT_URL_DEV,
  [`${GLOBAL_ENV.TIS_ENVIRONMENT}_DEV`]: process.env.TIS_ENVIRONMENT_DEV,
  // QA
  [`${GLOBAL_ENV.PLAY_ENVIRONMENT}_QA`]: process.env.PLAY_ENVIRONMENT_QA,
  [`${GLOBAL_ENV.LIVE_ENVIRONMENT}_QA`]: process.env.LIVE_ENVIRONMENT_QA,
  [`${GLOBAL_ENV.TIS_LOGIN_URL}_QA`]: process.env.TIS_LOGIN_URL_QA,
  [`${GLOBAL_ENV.TIS_LOGOUT_URL}_QA`]: process.env.TIS_LOGOUT_URL_QA,
  [`${GLOBAL_ENV.TIS_ENVIRONMENT}_QA`]: process.env.TIS_ENVIRONMENT_QA,
  // UAT
  [`${GLOBAL_ENV.PLAY_ENVIRONMENT}_UAT`]: process.env.PLAY_ENVIRONMENT_UAT,
  [`${GLOBAL_ENV.LIVE_ENVIRONMENT}_UAT`]: process.env.LIVE_ENVIRONMENT_UAT,
  [`${GLOBAL_ENV.TIS_LOGIN_URL}_UAT`]: process.env.TIS_LOGIN_URL_UAT,
  [`${GLOBAL_ENV.TIS_LOGOUT_URL}_UAT`]: process.env.TIS_LOGOUT_URL_UAT,
  [`${GLOBAL_ENV.TIS_ENVIRONMENT}_UAT`]: process.env.TIS_ENVIRONMENT_UAT,
  // NA
  [`${GLOBAL_ENV.PLAY_ENVIRONMENT}_NA`]: process.env.PLAY_ENVIRONMENT_NA,
  [`${GLOBAL_ENV.LIVE_ENVIRONMENT}_NA`]: process.env.LIVE_ENVIRONMENT_NA,
  [`${GLOBAL_ENV.TIS_LOGIN_URL}_NA`]: process.env.TIS_LOGIN_URL_NA,
  [`${GLOBAL_ENV.TIS_LOGOUT_URL}_NA`]: process.env.TIS_LOGOUT_URL_NA,
  [`${GLOBAL_ENV.TIS_ENVIRONMENT}_NA`]: process.env.TIS_ENVIRONMENT_NA,
  // NA Play
  [`${GLOBAL_ENV.PLAY_ENVIRONMENT}_PLAY_NA`]:
    process.env.PLAY_ENVIRONMENT_PLAY_NA,
  [`${GLOBAL_ENV.LIVE_ENVIRONMENT}_PLAY_NA`]:
    process.env.LIVE_ENVIRONMENT_PLAY_NA,
  [`${GLOBAL_ENV.TIS_LOGIN_URL}_PLAY_NA`]: process.env.TIS_LOGIN_URL_PLAY_NA,
  [`${GLOBAL_ENV.TIS_LOGOUT_URL}_PLAY_NA`]: process.env.TIS_LOGOUT_URL_PLAY_NA,
  [`${GLOBAL_ENV.TIS_ENVIRONMENT}_PLAY_NA`]:
    process.env.TIS_ENVIRONMENT_PLAY_NA,
  // APAC
  [`${GLOBAL_ENV.PLAY_ENVIRONMENT}_APAC`]: process.env.PLAY_ENVIRONMENT_APAC,
  [`${GLOBAL_ENV.LIVE_ENVIRONMENT}_APAC`]: process.env.LIVE_ENVIRONMENT_APAC,
  [`${GLOBAL_ENV.TIS_LOGIN_URL}_APAC`]: process.env.TIS_LOGIN_URL_APAC,
  [`${GLOBAL_ENV.TIS_LOGOUT_URL}_APAC`]: process.env.TIS_LOGOUT_URL_APAC,
  [`${GLOBAL_ENV.TIS_ENVIRONMENT}_APAC`]: process.env.TIS_ENVIRONMENT_APAC,
  // APAC Play
  [`${GLOBAL_ENV.PLAY_ENVIRONMENT}_PLAY_APAC`]:
    process.env.PLAY_ENVIRONMENT_PLAY_APAC,
  [`${GLOBAL_ENV.LIVE_ENVIRONMENT}_PLAY_APAC`]:
    process.env.LIVE_ENVIRONMENT_PLAY_APAC,
  [`${GLOBAL_ENV.TIS_LOGIN_URL}_PLAY_APAC`]:
    process.env.TIS_LOGIN_URL_PLAY_APAC,
  [`${GLOBAL_ENV.TIS_LOGOUT_URL}_PLAY_APAC`]:
    process.env.TIS_LOGOUT_URL_PLAY_APAC,
  [`${GLOBAL_ENV.TIS_ENVIRONMENT}_PLAY_APAC`]:
    process.env.TIS_ENVIRONMENT_PLAY_APAC
};

export const MAX_FILE_SIZE_LIMIT = 100 * 1024 * 1024; // 100 MB
export const GATEWAY_IMAGE_MAX_SIZE = 2 * 1024 * 1024; //2MB

export const ALTERNATE_CUSTOMER_NUMBER_MIN_LENGHT = 7;
export const ALTERNATE_CUSTOMER_NUMBER_MAX_LENGHT = 9;

export const AWS_URL = "s3.amazonaws.com";

export const DATA_MANAGEMENT_TASKS = {
  ARCHIVE_CONTRACT: "archiveContract"
} as const;

export const DEFAULT_US_ZIP_MASK = "99999?????";

export const GATEWAY_TOP_LEVEL_CATEGORY_PARENT_ID = "0";

export const GW_USER_LIST_SHEET_NAME = "Users";

export const COLOR_PICKER_TYPE = {
  RGB: {
    value: "rgb",
    label: "RGB"
  },
  HEX: {
    value: "hex",
    label: "HEX"
  }
};

export const SRM_MAX_ALLOWED_PHONE_LENGTH = 12;

export const MAX_ALLOWED_QUERY_LENGTH = 2000;
